document.querySelectorAll('[data-ol-tabs]').forEach(function (root) {
  var tabs = root.querySelectorAll('[role="tab"]');
  var panels = root.querySelectorAll('[role="tabpanel"]');
  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        panels[j].hidden = i !== j;
      });
    });
  });
});
document.addEventListener('click', function (e) {
  document.querySelectorAll('.ol-header__menu[open]').forEach(function (d) {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});
